import React from "react";
import { Box, Flex, Text } from "rebass";
import { OptionsType } from "react-select/src/types";

import { Select, IOption } from "../../../../../components/Select";

interface IProps {
  title: string;
  value: string;
  options: OptionsType<IOption>;
  isDisabled?: boolean;
  handleOnChange(value: string): void;
}

export function SelectTemplate({ title, value, options, handleOnChange, isDisabled }: IProps) {
  return (
    <Flex alignItems="center">
      <Text
        mr="20px"
        color="zodiac"
        fontSize="16px"
        fontWeight={600}
      >
        {title}
      </Text>

      <Box width="250px" ml="auto">
        <Select
          value={value}
          options={options}
          handleOnChange={handleOnChange}
          isDisabled={isDisabled}
        />
      </Box>
    </Flex>
  );
}
